module.exports = __webpack_public_path__ + "static/HSE_Exchange_Announcement_Extension_to_July_31-4373502e77ccf764a4ce5822bd439fb3.pdf";